export function getItemsExceedingInventory(order) {
  return order.orderItems.filter(item => (
    'inventoryCount' in item
    && item.inventoryCount > 0
    && item.quantity > item.inventoryCount
  ));
}

export function getInvalidDaypartItems(order) {
  return order.orderItems.filter(item => item.unavailablePerSchedule);
}

export function getUnavailableItemsAndModifiers(order, ignoreOutOfStock = false) {
  return order.orderItems.reduce((unavailableItems, item) => {
    const itemIsUnavailable = item.currentlyUnavailable
      && (
        !ignoreOutOfStock
        || item.inventoryCount === 0
        || !item.currentlyOutOfStock
      );
    const unavailableModifiers = [];

    item.modifiers.forEach((modifier) => {
      if (modifier.currentlyUnavailable) {
        unavailableModifiers.push(modifier);
      }

      if (modifier.modifiers) {
        modifier.modifiers.forEach((nestedModifier) => {
          if (nestedModifier.currentlyUnavailable) {
            unavailableModifiers.push(nestedModifier);
          }
        });
      }
    });

    if (itemIsUnavailable || unavailableModifiers.length) {
      unavailableItems.push({ ...item, unavailableModifiers });
    }

    return unavailableItems;
  }, []);
}



export default {
  getItemsExceedingInventory,
  getInvalidDaypartItems,
  getUnavailableItemsAndModifiers
};
